import Head from "next/head";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { BotControlProvider } from "@medbillai/app/screens/auth/components/BotControlProvider";
import { LoginScreen } from "@medbillai/app/screens/auth/login";
import { SignUpOnboardingLayout } from "@medbillai/app/screens/sign-up-onboarding/layout.web";
import { FullscreenSpinner, isWeb } from "@medbillai/ui";
import { SlidingLayout } from "../utils/transition/SlidingLayout";
// Adjusted import to resolve error
import type { NextPageWithLayout } from "./_app";
const Page: NextPageWithLayout = () => {
  const router = useRouter();
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    if (router.isReady) {
      setIsLoading(false);
    }
  }, [router.isReady]);
  return <>
      <Head data-sentry-element="Head" data-sentry-source-file="login.tsx">
        <title>Login</title>
      </Head>
      {isLoading && isWeb !== undefined ? <FullscreenSpinner /> : <LoginScreen />}
    </>;
};
Page.getLayout = page => <SignUpOnboardingLayout>
    <SlidingLayout>
      <BotControlProvider>{page}</BotControlProvider>
    </SlidingLayout>
  </SignUpOnboardingLayout>;
export default Page;